import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entite',
  templateUrl: './entite.component.html',
  styleUrls: ['./entite.component.scss']
})
export class EntiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
